<section *ngIf="report" class="card p-6">

  <div class="grid grid-cols-2 gap-6">

    <div class="col-span-2">
      <div class="flex justify-between">
        <h2 class="text-xl font-semibold">Background</h2>
        <app-edit-button *ngIf="edit" [edit]="edit"></app-edit-button>
      </div>
    </div>

    <!-- Education -->
    <div class="col-span-2 xl:col-span-1">
      <h3 class="text-base font-semibold pb-6">Education</h3>
      <div class="grid grid-cols-12  gap-6 mb-3">

        <div *ngIf="!!report?.search_person?.education_history" class="col-span-12">
          <div *ngFor="let education of education(this.educationLength);" class="mb-1 " [@fadeInOut]="true">
            <div class="flex items-center justify-between text-xs  text-secondary-900">
              <div class="flex items-center w-full">
                <div class="h-12 w-12 mr-3">
                  <img [src]=" education.logo_url || 'assets/images/human.svg'"
                       (error)="onImageError($event, education)"
                       class="h-full w-full object-cover rounded-md" />
                </div>
                <div class="mr-2 w-2/3" *ngIf="education?.school || education?.degree_name || education?.field_of_study  ">
                    <p class="text-sm font-semibold">{{ education?.school}}</p>
                    <p class="text-xs ">{{ education?.degree_name }} ,{{ education?.field_of_study }} </p>
                </div>
                </div>
                <div class=" w-20 flex justify-end "  *ngIf="education.degree_name != null || education.field_of_study != null" >
                  <span class="text-xs">{{ education?.starts_at ? education.starts_at['year'] : '' }}-{{ education?.ends_at  ? education?.ends_at['year'] : ''}}</span>
                </div>
            </div>
          </div>

          <a *ngIf="readMoreEducation()" (click)="showEducation(true,report.search_person.education_history.length)"  class="text-xs mt-6 cursor-pointer text-blue-custom underline" >See all {{report.search_person.education_history.length-2}}  educational entries</a>

          <a *ngIf="!readMoreEducation() && report.search_person.education_history.length >2 " (click)="showEducation(false,2)"  class="text-xs mt-6 cursor-pointer text-blue-custom underline">Show Less</a>

        </div>

      </div>

      <div *ngIf="company" class="blue-card p-3">

        <app-assistant-prompt tag="ASK_ASSISTANT_EDUCATION_INSIGHT"
                              title="Education"
                              [type]="'insights'"
                              [company]="company"
                              [reportId]="reportSearch?.id"
                              [showButton]="true"
                              [buttonType]="1">
        </app-assistant-prompt>

      </div>

    </div>
    <!-- / Education -->

    <!-- Career -->
    <div class="col-span-2 xl:col-span-1">
      <h3 class="text-base font-semibold pb-6">Career</h3>
      <div class="grid grid-cols-12 gap-6 mb-3">

        <div class="col-span-12 " *ngIf="!!report.search_person.job_history">
          <div *ngFor="let career of career(this.careerLength);" class="mb-1" [@fadeInOut]="true">
            <div class="flex items-center w-full justify-between text-xs text-secondary-900">
              <div class="flex items-center w-full">
                <div class="h-12 w-12 mr-3">
                  <img [src]="career.logo_url || 'assets/images/human.svg'"
                       (error)="onImageError($event, career)"
                       class="h-full w-full object-cover rounded-md" />
                </div>
                <div class="mr-2 w-2/3 ">
                  <p class="text-sm font-semibold">{{ career.title }}</p>
                  <p class="text-xs">{{ career.company }}</p>
                </div>
              </div>
              <div class="w-32 flex justify-end">
                <span class="text-xs">{{career.starts_at ?  career.starts_at['year'] : ''}}-{{ career.ends_at ?  career.ends_at.year : "Present"}}</span>
              </div>
            </div>
          </div>

          <a *ngIf="readMoreCareer()" (click)="showCareer(true,report.search_person.job_history.length)" class="text-xs cursor-pointer text-blue-custom underline">See all {{report.search_person.job_history.length - 2}} career entries</a>

          <a *ngIf="!readMoreCareer() && report.search_person.job_history.length >2" (click)="showCareer(false,2)" class="text-xs cursor-pointer text-blue-custom underline">Show Less</a>
        </div>

      </div>

      <div *ngIf="company" class="blue-card p-3">

        <app-assistant-prompt tag="ASK_ASSISTANT_ADVANCED_CAREER"
                              title="Career"
                              [type]="'insights'"
                              [company]="company"
                              [reportId]="reportSearch?.id"
                              [showButton]="true"
                              [buttonType]="1">
        </app-assistant-prompt>

      </div>

    </div>
    <!-- / Career -->

  </div>

</section>
